import { render, staticRenderFns } from "./AlertsListDialog.vue?vue&type=template&id=04388fcb&scoped=true"
import script from "./AlertsListDialog.vue?vue&type=script&lang=ts"
export * from "./AlertsListDialog.vue?vue&type=script&lang=ts"
import style0 from "./AlertsListDialog.vue?vue&type=style&index=0&id=04388fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04388fcb",
  null
  
)

export default component.exports